import FrameStore from './FrameStore';
import basicStore from './BasicStore';
import LoginStore from './LoginStore';
import SubscriptionStore from './SubscriptionStore';
import LogMonitorStore from './LogMonitorStore';
import TrafficPermissionStore from './TrafficPermissionStore';
import OverviewStore from './OverviewStore';
import HeaderStore from './HeaderStore';
import PermissionStore from './PermissionStore';
import ApiStore from './ApiStore';

const frameStore = new FrameStore();
const loginStore = new LoginStore();
const subscriptionStore = new SubscriptionStore();
const logMonitorStore = new LogMonitorStore();
const overviewStore = new OverviewStore();
const headerStore = new HeaderStore();
const permissionStore = new PermissionStore();
const trafficPermissionStore = new TrafficPermissionStore();
const apiStore = new ApiStore()

export default function useStores() {
  return {
    frameStore,
    basicStore,
    loginStore,
    subscriptionStore,
    logMonitorStore,
    overviewStore,
    headerStore,
    permissionStore,
    trafficPermissionStore,
    apiStore
  }
}